import { useTu } from "@src/appV2/i18n/useTu";
import { Stack } from "@mui/material";
import { type UseModalState } from "@src/lib/ui-react";
import { Button } from "../../../components/Button";
import { Dialog } from "../../../components/Dialog";
import { Text } from "../../../components/Text";
import { LOCK_EXPIRY_DAYS } from "../constants";

interface LockedByOtherDialogProps {
  modalState: UseModalState;
}

export function LockedByOtherDialog(props: LockedByOtherDialogProps) {
  const { tu } = useTu("chat");

  const { modalState } = props;

  return (
    <Dialog modalState={modalState} title={tu("Professional's account locked")}>
      <Stack gap={3}>
        <Text>
          {tu(
            "This professional's account has been locked by another workplace. While locked, this professional:"
          )}
        </Text>
        <Stack component="ul" gap={1} sx={{ margin: 0, paddingLeft: 4 }}>
          <li>
            <Text>{tu("Cannot accept new Home Health visits")}</Text>
          </li>
          <li>
            <Text>{tu("Cannot be assigned to new cases")}</Text>
          </li>
        </Stack>
        <Text>
          {tu("The lock will expire automatically after {{days}} days.", {
            values: { days: LOCK_EXPIRY_DAYS },
          })}
        </Text>
      </Stack>
      <Stack direction="row" justifyContent="flex-end" sx={{ marginTop: 4 }}>
        <Button variant="outlined" onClick={modalState.closeModal}>
          OK
        </Button>
      </Stack>
    </Dialog>
  );
}
